import * as $ from "jquery";
export class cardCarousel {
	$scope: any = $(".card-carousel-wrapper");
	$container: any = $(".card-carousel-wrapper");



	slider(): any {
		let slideLeftBtn: any = $(".left-btn");
		let slideRightBtn: any = $(".right-btn");
		let currentIndex: Number | any = 0;
		if (this.$container.length === 1) {
			
			let cards: any = document.querySelectorAll(".card-carousel-wrapper .card-slide");
		

			cards.forEach((cardSlide: any, index: any) => {
				cardSlide.style.left = `${index * 100}%`;
			});
			if (currentIndex === 0) {
				slideLeftBtn.addClass("disabled-btn");
			}
			if (currentIndex === cards.length - 1) {
				slideRightBtn.addClass("disabled-btn");
			}
			const slidePrev = () => {
				if (currentIndex === 0) {
					return;
				}
				currentIndex--;
				if (currentIndex === 0) {
				slideLeftBtn.addClass("disabled-btn");
				}
				if (currentIndex > 0) {
					slideLeftBtn.removeClass("disabled-btn");
				}
				if (currentIndex !== cards.length - 1) {
				slideRightBtn.removeClass("disabled-btn");
				}

				slideCard();
			};
			const slideNext = () => {
				if (currentIndex !== cards.length - 1) {
					currentIndex++;
				}

				if (currentIndex === cards.length - 1) {
					slideRightBtn.addClass("disabled-btn");
				}
				if (currentIndex !== cards.length - 1) {
					slideRightBtn.removeClass("disabled-btn");
				}
				if (currentIndex !== 0) {
			slideLeftBtn.removeClass("disabled-btn");
				}

				slideCard();
			};
			const slideCard = () => {
				cards.forEach((cardSlide: any) => {
					cardSlide.style.transform = `translateX(-${
						currentIndex * 100
					}%)`;
				});
			};
			slideLeftBtn.on("click", slidePrev);

			slideRightBtn.on("click", slideNext);
		} else {
			let count: any = 0;
			

			for (let carousel of this.$container) {
				let cls: any = `carousel-${count}`;
				$(carousel).addClass(cls);
				let cardCls:any = `.${cls}`+' .card-slide'
				let slideLeftBtn: any = $(`.${cls} .left-btn`);
				let slideRightBtn: any = $(`.${cls} .right-btn`);
				let currentIndex: Number | any = 0;

				let cards: any = document.querySelectorAll(cardCls);
			

				cards.forEach((cardSlide: any, index: any) => {
					cardSlide.style.left = `${index * 100}%`;
				});
				if (currentIndex === 0) {
					slideLeftBtn.addClass("disabled-btn");
				}
				if (currentIndex === cards.length - 1) {
					slideRightBtn.addClass("disabled-btn");
				}
				const slidePrev = () => {
					if (currentIndex === 0) {
						return;
					}
					currentIndex--;
					if (currentIndex === 0) {
						slideLeftBtn.addClass("disabled-btn");
					}
					if (currentIndex > 0) {
						slideLeftBtn.removeClass("disabled-btn");
					}
					if (currentIndex !== cards.length - 1) {
					slideRightBtn.removeClass("disabled-btn");
					}

					slideCard();
				};
				const slideNext = () => {
					if (currentIndex !== cards.length - 1) {
						currentIndex++;
					}

					if (currentIndex === cards.length - 1) {
						slideRightBtn.addClass("disabled-btn");
					}
					if (currentIndex !== cards.length - 1) {
						slideRightBtn.removeClass("disabled-btn");
					}
					if (currentIndex !== 0) {
					slideLeftBtn.removeClass("disabled-btn");
					}

					slideCard();
				};
				const slideCard = () => {
					cards.forEach((cardSlide: any) => {
						cardSlide.style.transform = `translateX(-${
							currentIndex * 100
						}%)`;
					});
				};
				slideLeftBtn.on("click", slidePrev);

				slideRightBtn.on("click", slideNext);
				count++
			}
		}
	}
}
let scope: Element = document.querySelector(".card-carousel-wrapper");

if (scope) {
	try {
		$(document).ready(function () {
			let cardCarouselcomponent = new cardCarousel();
			cardCarouselcomponent.slider();
		});
	} catch (e) {
		console.error(e);
	}
}
